"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogLevel = void 0;
var LogLevel;
exports.LogLevel = LogLevel;

(function (LogLevel) {
  LogLevel["INFO"] = "INFO";
  LogLevel["DEBUG"] = "DEBUG";
  LogLevel["WARN"] = "WARN";
  LogLevel["ERROR"] = "ERROR";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Nb2RlbC9Mb2dMZXZlbC50cyJdLCJuYW1lcyI6WyJMb2dMZXZlbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0lBQVlBLFE7OztXQUFBQSxRO0FBQUFBLEVBQUFBLFE7QUFBQUEsRUFBQUEsUTtBQUFBQSxFQUFBQSxRO0FBQUFBLEVBQUFBLFE7R0FBQUEsUSx3QkFBQUEsUSIsInNvdXJjZVJvb3QiOiJvY3NkazovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBMb2dMZXZlbCB7XG4gIElORk8gPSBcIklORk9cIixcbiAgREVCVUcgPSBcIkRFQlVHXCIsXG4gIFdBUk4gPSBcIldBUk5cIixcbiAgRVJST1IgPSBcIkVSUk9SXCJcbn1cbiJdfQ==